module.exports = __webpack_public_path__ + "img/MA.974b3054.svg";